import { ListWcClaimsInput, ListWcClaimsCommand } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

/**
 * Extended input type for listWcClaims that includes the countries parameter.
 * The backend may not yet support this field, so it is optional for forward compatibility.
 */
export interface ExtendedListWcClaimsInput extends ListWcClaimsInput {
  countries?: string[];
}

export async function listWcClaimsService(input: ExtendedListWcClaimsInput) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return null;
  }
  const command = new ListWcClaimsCommand(input);
  const metricsPublisher = new MetricsPublisher("api.listWcClaims");

  return await client
    .send(command)
    .then((response) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
